import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAutoFocus } from "@/hooks/useAutoFocus";
import { A11yValue } from "@/components/A11yValue";
import { getBestScore } from "@/play/storage";
import { primeSpeech } from "@/play/speech";
import { primeSound } from "@/play/sound";

export default function Home() {
  const navigate = useNavigate();
  const headingRef = useAutoFocus();
  const [best, setBest] = useState(0);

  useEffect(() => {
    setBest(getBestScore());
  }, []);

  return (
    <main className="home" data-testid="home-screen">
      <section className="home__hero">
        <h1
          className="home__title"
          data-testid="home-title"
          aria-label="FOCUSTAP"
          tabIndex={-1}
          ref={headingRef}
        >
          FOCUS<span className="accent">TAP</span>
        </h1>
        <p className="home__tagline">
          Un tocco. Sei secondi. Attenzione, memoria e trabocchetti.
        </p>
      </section>

      <div className="home__actions">
        <button
          type="button"
          className="btn-primary"
          data-testid="home-new-game-button"
          onClick={() => {
            primeSpeech();
            primeSound();
            navigate("/game");
          }}
        >
          NUOVA PARTITA
        </button>
        <button
          type="button"
          className="btn-ghost"
          data-testid="home-leaderboard-button"
          onClick={() => navigate("/classifica")}
        >
          CLASSIFICA
        </button>
        <button
          type="button"
          className="btn-ghost"
          data-testid="home-settings-button"
          onClick={() => navigate("/settings")}
        >
          IMPOSTAZIONI
        </button>
      </div>

      <div className="home__footer">
        <Link
          to="/come-si-gioca"
          className="home__howto-link"
          data-testid="home-how-to-play-link"
        >
          Come si gioca
        </Link>
        <nav className="home__links" aria-label="Informazioni">
          <Link to="/accessibilita" className="home__mini-link" data-testid="home-accessibility-link">
            Accessibilità
          </Link>
          <Link to="/info" className="home__mini-link" data-testid="home-info-link">
            Info
          </Link>
          <Link to="/privacy" className="home__mini-link" data-testid="home-privacy-link">
            Privacy
          </Link>
        </nav>
        <A11yValue
          className="home__record"
          testId="home-best-score"
          visual={
            <>
              RECORD <b>{best > 0 ? best : "—"}</b>
            </>
          }
          spoken={best > 0 ? `Record personale: ${best}` : "Record personale: nessuno ancora"}
        />
      </div>
    </main>
  );
}
